export const APP_INITIALIZED = 'APP_INITIALIZED'

export const TOKEN_CHANGE = 'TOKEN_CHANGE'
export const STEP_SELECTED = 'STEP_SELECTED'
export const STEP_CONTROL_NEXT = 'STEP_CONTROL_NEXT'
export const STEP_CONTROL_PREV = 'STEP_CONTROL_PREV'
export const STEP_SELECT_LATEST = 'STEP_SELECT_LATEST'

export const STEP_FORCE_VALIDATION = 'STEP_FORCE_VALIDATION'


export const DOMAIN_INPUT_CHANGE = "DOMAIN_INPUT_CHANGE"
export const DOMAIN_CHECK_BEGIN = "DOMAIN_CHECK_BEGIN"
export const DOMAIN_LOAD_MORE = "DOMAIN_LOAD_MORE"
export const DOMAIN_HIDE_GONE = "DOMAIN_HIDE_GONE"

export const ALTERNATE_SEPA_TOGGLE = "ALTERNATE_SEPA_TOGGLE"

export const COLLAPSIBLE_CONTENT_TOGGLED = "COLLAPSIBLE_CONTENT_TOGGLED"
export const COLLAPSIBLE_OPEN_CONTENT = "COLLAPSIBLE_OPEN_CONTENT"
export const COLLAPSIBLE_CLOSE_CONTENT = "COLLAPSIBLE_CLOSE_CONTENT"

export const TOGGLE_SELECTION_TRIGGERED = "TOGGLE_SELECTION_TRIGGERED"

export const BASE_ARTICLE_REQUEST = 'BASE_ARTICLE_REQUEST'
export const BASE_ARTICLE_SUCCESS = 'BASE_ARTICLE_SUCCESS'
export const BASE_ARTICLE_FAILURE = 'BASE_ARTICLE_FAILURE'

export const PRODUCT_SET_CURRENT = 'PRODUCT_SET_CURRENT'

export const BASE_ARTICLE_SELECT = 'BASE_ARTICLE_SELECT'
export const BASE_ARTICLE_DESELECT = 'BASE_ARTICLE_DESELECT'
export const BASE_ARTICLE_LOAD_START = 'BASE_ARTICLE_LOAD_START'
export const BASE_ARTICLE_LOAD_COMPLETE = 'BASE_ARTICLE_LOAD_COMPLETE'
export const BASE_ARTICLE_CUSTOM_SELECTED = 'BASE_ARTICLE_CUSTOM_SELECTED'

export const BANKACCOUNT_VERIFY_REQUEST = 'BANKACCOUNT_VERIFY_REQUEST'
export const BANKACCOUNT_VERIFY_SUCCESS = 'BANKACCOUNT_VERIFY_SUCCESS'
export const BANKACCOUNT_VERIFY_FAILURE = 'BANKACCOUNT_VERIFY_FAILURE'

export const ARTICLEOPTION_DATA_REQUEST = 'ARTICLEOPTION_DATA_REQUEST'
export const ARTICLEOPTION_DATA_SUCCESS = 'ARTICLEOPTION_DATA_SUCCESS'
export const ARTICLEOPTION_DATA_FAILURE = 'ARTICLEOPTION_DATA_FAILURE'

export const CUSTOMER_CATEGORIES_REQUEST = 'CUSTOMER_CATEGORIES_REQUEST'
export const CUSTOMER_CATEGORIES_FAILURE = 'CUSTOMER_CATEGORIES_FAILURE'
export const CUSTOMER_CATEGORIES_SUCCESS = 'CUSTOMER_CATEGORIES_SUCCESS'

export const SOFTWARE_REQUEST = 'SOFTWARE_REQUEST'
export const SOFTWARE_FAILURE = 'SOFTWARE_FAILURE'
export const SOFTWARE_SUCCESS = 'SOFTWARE_SUCCESS'
export const SELECT_SOFTWARE = 'SOFTWARE_SELECT'


export const DATABASE_REQUEST = 'DATABASE_REQUEST'
export const DATABASE_FAILURE = 'DATABASE_FAILURE'
export const DATABASE_SUCCESS = 'DATABASE_SUCCESS'
export const SELECT_DATABASE = 'DATABASE_SELECT'


export const SELECT_BILLINGPERIOD = 'SELECT_BILLINGPERIOD'
export const SELECT_CART_PROPERTY = 'SELECT_CART_PROPERTY'


export const OPERATINGSYSTEM_REQUEST = 'OPERATINGSYSTEM_REQUEST'
export const OPERATINGSYSTEM_FAILURE = 'OPERATINGSYSTEM_FAILURE'
export const OPERATINGSYSTEM_SUCCESS = 'OPERATINGSYSTEM_SUCCESS'
export const SELECT_OPERATINGSYSTEM = 'OPERATINGSYSTEM_SELECT'

export const SEND_OFFER_REQUEST = 'SEND_OFFER_REQUEST'
export const SEND_OFFER_SUCCESS = 'SEND_OFFER_SUCCESS'
export const SEND_OFFER_FAILURE = 'SEND_OFFER_FAILURE'
export const SEND_OFFER_COPY = 'SEND_OFFER_COPY'
export const SEND_OFFER_COPY_RESET = 'SEND_OFFER_COPY_RESET'

export const PROMOTIONCODE_VALIDATE_REQUEST = 'PROMOTIONCODE_VALIDATE_REQUEST'
export const PROMOTIONCODE_VALIDATE_SUCCESS = 'PROMOTIONCODE_VALIDATE_SUCCESS'
export const PROMOTIONCODE_VALIDATE_FAILURE = 'PROMOTIONCODE_VALIDATE_FAILURE'

export const PROMOTIONCODE_DATA_REQUEST = 'PROMOTIONCODE_DATA_REQUEST'
export const PROMOTIONCODE_DATA_SUCCESS = 'PROMOTIONCODE_DATA_SUCCESS'
export const PROMOTIONCODE_DATA_FAILURE = 'PROMOTIONCODE_DATA_FAILURE'

export const PROMOTIONCODE_RESET = 'PROMOTIONCODE_RESET'
export const PROMOTIONCODE_INIT = 'PROMOTIONCODE_INIT'

export const BEARER_TOKEN_REQUEST = 'BEARER_TOKEN_REQUEST'
export const BEARER_TOKEN_CACHE = 'BEARER_TOKEN_CACHE'
export const BEARER_TOKEN_SUCCESS = 'BEARER_TOKEN_SUCCESS'
export const BEARER_TOKEN_FAILURE = 'BEARER_TOKEN_FAILURE'

export const TOPLEVELDOMAINS_REQUEST = "TOPLEVELDOMAINS_REQUEST"
export const TOPLEVELDOMAINS_SUCCESS = "TOPLEVELDOMAINS_SUCCESS"
export const TOPLEVELDOMAINS_FAILURE = "TOPLEVELDOMAINS_FAILURE"

export const DOMAIN_CHECK_REQUEST = "DOMAIN_CHECK_REQUEST"
export const DOMAIN_CHECK_SUCCESS = "DOMAIN_CHECK_SUCCESS"
export const DOMAIN_CHECK_FAILURE = "DOMAIN_CHECK_FAILURE"


export const CART_CREATE_REQUEST = "CART_CREATE_REQUEST"
export const CART_CREATE_SUCCESS = "CART_CREATE_SUCCESS"
export const CART_CREATE_FAILURE = "CART_CREATE_FAILURE"


export const CART_SHARE_REQUEST = "CART_SHARE_REQUEST"
export const CART_SHARE_SUCCESS = "CART_SHARE_SUCCESS"
export const CART_SHARE_FAILURE = "CART_SHARE_FAILURE"

export const CART_UPDATE_REQUEST = "CART_UPDATE_REQUEST"
export const CART_UPDATE_SUCCESS = "CART_UPDATE_SUCCESS"
export const CART_UPDATE_FAILURE = "CART_UPDATE_FAILURE"

export const CART_CHECKOUT_REQUEST = "CART_CHECKOUT_REQUEST"
export const CART_CHECKOUT_SUCCESS = "CART_CHECKOUT_SUCCESS"
export const CART_CHECKOUT_FAILURE = "CART_CHECKOUT_FAILURE"

export const CART_RECOMMEND_REQUEST = "CART_RECOMMEND_REQUEST"
export const CART_RECOMMEND_SUCCESS = "CART_RECOMMEND_SUCCESS"
export const CART_RECOMMEND_FAILURE = "CART_RECOMMEND_FAILURE"

export const CART_PINCODE_VERIFY_REQUEST = "CART_PINCODE_VERIFY_REQUEST"
export const CART_PINCODE_VERIFY_RESPONSE = "CART_PINCODE_VERIFY_RESPONSE"
export const CART_PINCODE_VERIFY_FAILURE = "CART_PINCODE_VERIFY_FAILURE"
export const CART_PINCODE_VERIFY_SUCCESS = "CART_PINCODE_VERIFY_SUCCESS"

export const CART_REMOVE_ITEM_REQUEST = "CART_REMOVE_ITEM_REQUEST"
export const CART_REMOVE_ITEM_SUCCESS = "CART_REMOVE_ITEM_SUCCESS"
export const CART_REMOVE_ITEM_FAILURE = "CART_REMOVE_ITEM_FAILURE"

export const CART_ADD_ITEM_REQUEST = 'CART_ADD_ITEM_REQUEST'
export const CART_ADD_ITEM_SUCCESS = 'CART_ADD_ITEM_SUCCESS'
export const CART_ADD_ITEM_FAILURE = 'CART_ADD_ITEM_FAILURE'

export const CART_ADD_DOMAIN_REQUEST = 'CART_ADD_DOMAIN_REQUEST'
export const CART_ADD_DOMAIN_SUCCESS = 'CART_ADD_DOMAIN_SUCCESS'
export const CART_ADD_DOMAIN_FAILURE = 'CART_ADD_DOMAIN_FAILURE'

export const NEOS_ARTICLEDATA_REQUEST = 'NEOS_ARTICLEDATA_REQUEST'
export const NEOS_ARTICLEDATA_SUCCESS = 'NEOS_ARTICLEDATA_SUCCESS'
export const NEOS_ARTICLEDATA_FAILURE = 'NEOS_ARTICLEDATA_FAILURE'

export const CART_PUT_FORM_DATA_REQUEST = 'CART_PUT_FORM_DATA_REQUEST'
export const CART_PUT_FORM_DATA_SUCCESS = 'CART_PUT_FORM_DATA_SUCCESS'
export const CART_PUT_FORM_DATA_FAILURE = 'CART_PUT_FORM_DATA_FAILURE'

export const CART_QUERYPROJECT_START = 'CART_QUERYPROJECT_START';
export const CART_QUERYPROJECT_COMPLETE = 'CART_QUERYPROJECT_COMPLETE';


export const CART_SET_INITIAL = "CART_SET_INITIAL"

export const CLIENTDATA_SELECT_EXISTING = 'CLIENTDATA_SELECT_EXISTING'
export const CLIENTDATA_SELECT_NEW = 'CLIENTDATA_SELECT_NEW'

export const AUTHENTICATION_REQUEST = 'AUTHENTICATION_REQUEST'
export const AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE'
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS'
export const AUTHENTICATION_CACHED = 'AUTHENTICATION_CACHED'

export const CLIENTNUMBER_REQUEST = 'CLIENTNUMBER_REQUEST'
export const CLIENTNUMBER_SUCCESS = 'CLIENTNUMBER_SUCCESS'
export const CLIENTNUMBER_FAILURE = 'CLIENTNUMBER_FAILURE'

export const ACCOUNTS_REQUEST = 'ACCOUNTS_REQUEST'
export const ACCOUNTS_SUCCESS = 'ACCOUNTS_SUCCESS'
export const ACCOUNTS_FAILURE = 'ACCOUNTS_FAILURE'

export const PRE_UPGRADECHECK_REQUEST = 'PRE_UPGRADECHECK_REQUEST'
export const PRE_UPGRADECHECK_SUCCESS = 'PRE_UPGRADECHECK_SUCCESS'
export const PRE_UPGRADECHECK_FAILURE = 'PRE_UPGRADECHECK_FAILURE'

export const CONTRACTS_REQUEST = 'CONTRACTS_REQUEST'
export const CONTRACTS_SUCCESS = 'CONTRACTS_SUCCESS'
export const CONTRACTS_FAILURE = 'CONTRACTS_FAILURE'

export const RESELLERS_REQUEST = 'RESELLERS_REQUEST'
export const RESELLERS_SUCCESS = 'RESELLERS_SUCCESS'
export const RESELLERS_FAILURE = 'RESELLERS_FAILURE'

export const CLIENTDATA_REQUEST = 'CLIENTDATA_REQUEST'
export const CLIENTDATA_SUCCESS = 'CLIENTDATA_SUCCESS'
export const CLIENTDATA_FAILURE = 'CLIENTDATA_FAILURE'

export const POPUP_SHOW_OFFER_SHARING = 'POPUP_SHOW_OFFER_SHARING'
export const POPUP_SHOW_IFRAME = 'POPUP_SHOW_IFRAME'
export const POPUP_CLOSE_ANY = 'POPUP_CLOSE_ANY'

export const SUPPORT_BOX_HIDDEN = 'SUPPORT_BOX_HIDDEN'
export const SUPPORT_BOX_SHOWN = 'SUPPORT_BOX_SHOWN'

export const CONFIGURATION_SCROLL_PROGRESS = 'CONFIGURATION_SCROLL_PROGRESS'
export const STEP_UNDONE = 'STEP_UNDONE'

export const FORM_TOGGLE_PASSWORD_VISIBILITY = 'FORM_TOGGLE_PASSWORD_VISIBILITY';



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/